<template>
	<div>
		<topTab ref="topTab" :tab-data="tabData" @tab-change="changePages">
			<el-form :inline="true" :model="formInline" class="user-search">
				<el-form-item label="订单编号：">
					<el-input clearable v-model="formInline.orderNo" size="small" placeholder="请输入订单编号" @keyup.enter.native="inputChange"></el-input>
				</el-form-item>
				<el-form-item label="所属门店：">
					<el-select filterable v-model="formInline.belongStoreKeyId" placeholder="请选择门店" clearable size="small" @change="getListData">
						<el-option v-for="item in storeList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="订单状态：">
					<el-select v-model.number="formInline.state" placeholder="请选择订单状态" size="small" @change="getListData">
						<el-option v-for="item in stateList" :key="item.code" :label="item.name" :value="item.code"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="是否预警：">
					<el-select v-model.number="formInline.isWarningQuJing" placeholder="请选择是否预警" size="small" @change="getListData">
						<el-option :key="0" label="全部" :value="0"></el-option>
						<el-option :key="1" label="预警" :value="1"></el-option>
						<el-option :key="2" label="未预警" :value="2"></el-option>
						<el-option :key="3" label="超期" :value="3"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="订单来源：">
					<el-select v-model.number="formInline.orderSource" placeholder="请选择订单来源" size="small" @change="getListData">
						<el-option v-for="item in orderSourceList" :key="item.code" :label="item.name" :value="item.code"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="订单类型：">
					<el-select v-model.number="formInline.orderType" placeholder="请选择订单类型" size="small" @change="getListData">
						<el-option v-for="item in orderTypeList" :key="item.code" :label="item.name" :value="item.code"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="顾客姓名：">
					<el-input clearable v-model="formInline.customerName" size="small" placeholder="请输入顾客姓名" @keyup.enter.native="inputChange"></el-input>
				</el-form-item>
				<el-form-item label="顾客电话：">
					<el-input clearable v-model="formInline.customerPhone" size="small" placeholder="请输入顾客电话" @keyup.enter.native="inputChange"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button v-if="$checkBtnPermission('/order/index', 'viewPage')" size="small" type="primary" class="el-icon-search" @click="inputChange()">搜索</el-button>
					<el-button v-if="$checkBtnPermission('/order/index', 'reset')" size="small" icon="el-icon-refresh" @click="clearAll">重置</el-button>
					<el-button v-if="$checkBtnPermission('/order/index', 'highFilter')" size="small" plain icon="el-icon-search" @click="handleFilter()">高级筛选</el-button>
					<el-button v-if="$checkBtnPermission('/order/index', 'createOrder')" size="small" type="primary" class="el-icon-s-goods" @click="handleEdit()">创建订单</el-button>
					<el-button v-if="$checkBtnPermission('/order/index', 'confirmOrder')" size="small" type="primary" class="el-icon-s-check" @click="handleConfirmOrder()">订单确认</el-button>
					<el-button v-if="$checkBtnPermission('/order/index', 'batchInputStoreKDNo')" size="small" type="primary" class="el-icon-s-promotion" @click="handleBatchInputStoreKDNo()">
						批量录入快递单号
					</el-button>
					<el-button v-if="$checkBtnPermission('/order/index', 'finishedOrder')" size="small" type="danger" class="el-icon-finished" @click="handleFinishedOrder()">订单完成</el-button>
					<el-button v-if="$checkBtnPermission('/order/index', 'batchInputStoreKDNo')" size="small" type="warning" class="el-icon-s-promotion" @click="handleBatchEditKDNo()">
						批量修改快递单号
					</el-button>
					<my-column-filter v-if="$checkBtnPermission('/order/index', 'myFilter')" :list-columns="listColumns" @hide-pop="getCheckBox"></my-column-filter>
				</el-form-item>
			</el-form>
			<div class="table-minheight">
				<STable :columns="columnsData" :data="listData" :loading="loading" border height="535" @get-data="getListData" @row-db-click="handleRowDBClick" @selection-change="handleSelectionChange">
					<template #orderNo>
						<el-table-column align="center" label="订单编号" width="280">
							<template #default="scope">
								<el-link type="primary" size="small" @click="handleSeeDetail(scope.row)">
									{{ scope.row.orderNo }}
								</el-link>
							</template>
						</el-table-column>
					</template>
					<template #orderTypeStr>
						<el-table-column align="center" label="订单类型" width="100">
							<template #default="scope">
								<span v-if="scope.row.orderType === 2" class="one_2">
									{{ scope.row.orderTypeStr }}
								</span>
								<span v-else>
									{{ scope.row.orderTypeStr }}
								</span>
							</template>
						</el-table-column>
					</template>
					<template #machinTypeStr>
						<el-table-column align="center" label="加工类型" width="100">
							<template #default="scope">
								<span v-if="scope.row.machinType === 2" class="one_1">
									{{ scope.row.machinTypeStr }}
								</span>
								<span v-else>
									{{ scope.row.machinTypeStr }}
								</span>
							</template>
						</el-table-column>
					</template>
					<template #days>
						<el-table-column align="center" label="天数" min-width="60">
							<template #default="scope">
								<span v-if="scope.row.state === 6 || scope.row.state === 10 || scope.row.days === null || scope.row.days === undefined || scope.row.days === ''">--</span>
								<span v-else-if="scope.row.days <= delayDays && scope.row.days >= 0" class="one_1">
									{{ scope.row.days }}
								</span>
								<span v-else-if="scope.row.days < 0" class="one_2">
									{{ scope.row.days }}
								</span>
								<span v-else>
									{{ scope.row.days }}
								</span>
							</template>
						</el-table-column>
					</template>
					<el-table-column slot="storeKDNo" label="门店快递单号" width="180">
						<template #default="scope">
							<el-link v-if="scope.row.storeKDNo" type="primary" size="small" @click="openNewWindowSearchKuaiDi(scope.row.storeKDNo)">
								{{ scope.row.storeKDNo }}
							</el-link>
							<span v-else>
								{{ scope.row.storeKDNo }}
							</span>
						</template>
					</el-table-column>
					<el-table-column slot="storeKDNo" label="加工部快递单号" width="180">
						<template #default="scope">
							<el-link v-if="scope.row.jgbkdNo" type="primary" size="small" @click="openNewWindowSearchKuaiDi(scope.row.jgbkdNo)">
								{{ scope.row.jgbkdNo }}
							</el-link>
							<span v-else>
								{{ scope.row.jgbkdNo }}
							</span>
						</template>
					</el-table-column>
					<template #linkOrderNo>
						<el-table-column align="center" label="原订单号" width="280">
							<template #default="scope">
								<el-link type="primary" size="small" @click="handleSeeYuanDetail(scope.row)">
									{{ scope.row.linkOrderNo }}
								</el-link>
							</template>
						</el-table-column>
					</template>
					<template #actionHandle>
						<el-table-column align="center" label="操作" width="200" fixed="right">
							<template #default="scope">
								<el-button v-if="btnPermission.edit && (scope.row.state === 1 || scope.row.state === 2)" size="small" type="primary" class="el-icon-edit" @click="handleRowDBClick(scope.row)">
									修改
								</el-button>
								<el-button v-if="btnPermission.delete && scope.row.state === 1" size="small" type="danger" class="el-icon-delete" @click="handleDeleteOrder(scope.row)">删除</el-button>
							</template>
						</el-table-column>
					</template>
				</STable>
				<!-- 分页组件 -->
				<Pagination v-if="pageShow" :child-msg="pageparm" @call-father="callFather"></Pagination>
			</div>
		<storeDetail ref="storeDetail" :dialog-mode="true"></storeDetail>
		</topTab>
		<filterMore ref="filterMore" @filter-more-call-back="filterMoreCallBack"></filterMore>
		<create ref="create"></create>
		<edit ref="edit"></edit>
		<selectCustomer ref="selectCustomer"></selectCustomer>
		<selectGoods ref="selectGoods"></selectGoods>

		<!-- 批量录入快递单号 -->
		<el-dialog :visible.sync="dialogVisible" title="批量录入快递单号" width="60%" :close-on-click-modal="false">
			<span style="display: block; margin-bottom: 10px"><strong>快递单号:</strong></span>
			<el-input clearable v-model="kdNo" placeholder="请输入快递单号" maxlength="30" show-word-limit></el-input>
			<template #footer>
				<span>
					<el-button @click="dialogVisible = false">取消</el-button>
					<el-button type="primary" @click="handleKDNoSubmit">确认</el-button>
				</span>
			</template>
		</el-dialog>

		<!-- 批量修改快递单号 -->
		<el-dialog :visible.sync="dialogEditKDNoVisible" title="批量修改快递单号" width="60%" :close-on-click-modal="false">
			<span style="display: block; margin-bottom: 10px"><strong>快递单号:</strong></span>
			<el-input clearable v-model="editKDNo" placeholder="请输入快递单号" maxlength="30" show-word-limit></el-input>
			<template #footer>
				<span>
					<el-button @click="dialogEditKDNoVisible = false">取消</el-button>
					<el-button type="primary" @click="handleEditKDNoSubmit">确认</el-button>
				</span>
			</template>
		</el-dialog>
	</div>
</template>

<script>
import { GetStoreOrderPageList, BatchSaveStoreKDNo, ConfirmStoreOrder, FinishedStoreOrder, DeleteStoreOrder, BatchEditStoreKDNo } from "@/api/storeOrderApi.js";
import { GetOrgInfoListByConfig } from "@/api/organizationalApi.js";
import { GetEnumConfigListByCode } from "@/api/enumApi.js";
import { GetSystemBusinessConfigDetailByCode } from "@/api/systemApi.js";
import storeDetail from "./storeDtl.vue";
import create from "./create.vue";
import edit from "./edit.vue";
import selectCustomer from "@/views/baseData/customer/selectCustomer.vue";
import selectGoods from "@/views/baseData/goods/selectGoods.vue";
export default {
	data() {
		return {
			activeTab: "1",
			tabData: [
				{
					key: "1",
					value: "订单列表"
				}
			],
			pageShow: true,
			loading: false, // 显示加载
			searchTimer: null,
			listData: [],
			selectionList: [],
			selectionRowKeyIds: [],
			// 分页参数
			pageparm: {
				pageIndex: 1,
				pageSize: 10,
				total: 0
			},
			formInline: {
				pageIndex: 1,
				pageSize: 10,
				customerPhone: "",
				customerName: "",
				startTime: "",
				endTime: "",
				belongStoreKeyId: "",
				orderNo: "",
				storeKDNo: "",
				jgbkdNo: "",
				state: 0,
				isWarningQuJing: 0,
				orderSource: 0,
				orderType: 0,
				getOrderDateStart: "",
				getOrderDateEnd: ""
			},
			columnsData: [], //显示列
			listColumns: [
				{
					prop: "keyId",
					label: "全选",
					align: "center",
					width: "55",
					isKeep: true,
					selection: true
				},
				{
					prop: "rowNumber",
					label: "序号",
					align: "center",
					isKeep: true,
					width: "80"
				},
				{
					prop: "orderDate",
					label: "下单日期",
					width: "100",
					align: "center",
				},
				{
					prop: "belongStoreName",
					label: "所属门店",
					isKeep: true,
					width: "150",
					align: "center"
				},
				{
					prop: "customerInfo.name",
					label: "顾客姓名",
					width: "100",
					align: "center"
				},
				{
					slot: "orderNo",
					label: "订单编号",
					isKeep: true,
					width: "100"
				},
				{
					prop: "stateStr",
					label: "订单状态",
					isKeep: true,
					width: "100",
					align: "center"
				},
				{
					slot: "orderTypeStr",
					label: "订单类型",
					isKeep: true,
					width: "100",
					align: "center"
				},
				{
					prop: "getOrderDate",
					label: "取镜时间",
					width: "100",
					align: "center"
				},
				{
					slot: "days",
					label: "天数",
					minWidth: "60",
					align: "center"
				},
				{
					prop: "confirmUserName",
					label: "确认人",
					width: "100",
					align: "center"
				},
				{
					prop: "confirmTime",
					label: "确认时间",
					width: "160",
					align: "center"
				},
				{
					prop: "eyeGlassTypeStr",
					label: "镜片类型",
					width: "120",
					align: "center"
				},
				{
					prop: "customerInfo.phone",
					label: "顾客电话",
					width: "130",
					align: "center"
				},
				{
					prop: "yanGuangShi",
					label: "验光师",
					width: "100",
					align: "center"
				},
				{
					prop: "jjInformation",
					label: "镜架信息",
					minWidth: "150",
					align: "center"
				},
				{
					slot: "machinTypeStr",
					label: "加工类型",
					minWidth: "100",
					align: "center"
				},
				{
					prop: "orderSourceStr",
					label: "订单来源",
					minWidth: "100",
					align: "center"
				},
				{
					slot: "storeKDNo",
					label: "门店快递订单号",
					width: "220"
				},
				{
					slot: "jgbkdNo",
					label: "加工部快递订单号",
					width: "220"
				},
				{
					slot: "linkOrderNo",
					label: "原订单号",
					width: "220"
				},
				{
					prop: "creator",
					label: "创建人",
					width: "100"
				},
				{
					prop: "createTime",
					label: "创建时间",
					width: "160"
				},
				{
					prop: "editor",
					label: "维护人",
					width: "100"
				},
				{
					prop: "updateTime",
					label: "维护时间",
					width: "160"
				},
				{
					slot: "actionHandle",
					label: "操作",
					width: "160",
					align: "center",
					fixed: "right"
				}
			],
			chooseTime: "",
			storeList: [],
			stateList: [],
			orderTypeList: [],
			orderSourceList: [],
			dialogVisible: false,
			kdNo: "",
			// 按钮权限
			btnPermission: {
				delete: false,
				edit: false,
				batchEditKDNo: false
			},
			createOrEdit: 1, //1新增2修改
			delayDays: 1,
			// 批量修改快递单号
			dialogEditKDNoVisible: false,
			editKDNo: ""
		};
	},
	// 注册组件
	components: {
		storeDetail,
		create,
		edit,
		selectCustomer,
		selectGoods
	},
	created() {
		this.getCheckBox(this.listColumns.map((item) => item.label));
		this.getBtnPermission();
		this.getListData();
		Promise.all([
			this.GetSystemBusinessConfigDetailByCode(),
			this.GetOrgInfoListByConfig(),
			this.GetEnumConfigListByCode(),
			this.GetOrderSourceEnumConfigListByCode(),
			this.GetOrderTypeListByCode()
		]).catch(() => {});
	},
	computed: {},
	methods: {
		handleFilter() {
			let initForm = {
				initSearch: {
					pageIndex: 1,
					pageSize: 10
				},
				formList: [
					{
						label: "下单日期：",
						datePickerIsRange: true,
						startProp: "startTime",
						endProp: "endTime",
						valueFormat: "yyyy-MM-dd",
						pickerType: "daterange"
					},
					{
						label: "取镜日期：",
						datePickerIsRange: true,
						startProp: "getOrderDateStart",
						endProp: "getOrderDateEnd",
						valueFormat: "yyyy-MM-dd",
						pickerType: "daterange"
					},
					{
						label: "门店快递号：",
						prop: "storeKDNo",
						input: true
					},
					{
						label: "加工部快递号：",
						prop: "jgbkdNo",
						input: true
					}
				]
			};
			this.$refs.filterMore.filterShow(this.formInline, initForm);
		},
		// 获取筛选框
		getCheckBox(val) {
			let arr = this.listColumns.filter((v) => !val.includes(v.label));
			this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
		},
		changeTime(val) {
			if (val !== null) {
				this.formInline.startTime = val[0];
				this.formInline.endTime = val[1];
			} else {
				this.formInline.startTime = null;
				this.formInline.endTime = null;
			}
		},
		changePages() {},
		handleCommand(command) {
			// 1编辑
			switch (command.command) {
				case "4":
					this.deleteInfo(command.rowData);
					break;
				default:
					console.log(command);
			}
		},
		// 单击行数据
		handleRowClick(row) {
			this.$refs.edit.editShow(row);
		},
		//显示新增界面
		handleEdit() {
			this.createOrEdit = 1;
			this.$refs.create.showCreateDialog();
		},
		// 选择顾客
		showSelectCustomer() {
			this.$refs.selectCustomer.showSelectCustomerDialog();
		},
		// 选中顾客
		chooseCustomer(selectionKeyId) {
			this.$refs.create.submitSelect(selectionKeyId);
		},
		// 获取预警天数
		GetSystemBusinessConfigDetailByCode() {
			return GetSystemBusinessConfigDetailByCode({
				code: "QuJingWarningDay"
			}).then((res) => {
				if (res.code == 1) {
					this.delayDays = parseInt(res.data.delayDays) || 1;
				} else {
					this.$message.error(res.msg);
				}
			});
		},
		// 获取列表
		getListData() {
			this.loading = true;
			var params = {
				...this.formInline,
				belongStoreKeyId: this.formInline.belongStoreKeyId || null,
				startTime: this.formInline.startTime || null,
				endTime: this.formInline.endTime || null,
				getOrderDateStart: this.formInline.getOrderDateStart || null,
				getOrderDateEnd: this.formInline.getOrderDateEnd || null
			};
			GetStoreOrderPageList(params)
				.then((res) => {
					if (res.code == 1) {
						this.loading = false;
						this.listData = res.data;
						this.pageparm.total = res.totalNumber;
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},
		// 重置
		clearAll() {
			this.$data.formInline = this.$options.data.call(this).formInline;
			this.search();
		},
		inputChange(val) {
			this.search();
		},
		// 分页插件事件
		callFather(parm) {
			if (parm.currentPage == undefined) {
				this.formInline.pageIndex = 1;
			} else {
				this.formInline.pageIndex = parm.currentPage;
			}
			this.formInline.pageSize = parm.pageSize;
			this.getListData();
		},
		// 搜索事件
		search() {
			if (this.searchTimer) {
				clearTimeout(this.searchTimer);
			}
			this.searchTimer = setTimeout(() => {
				this.formInline.pageIndex = 1;
				this.pageShow = false;
				this.$nextTick(() => {
					this.pageShow = true;
				});
				this.getListData();
			}, 300);
		},
		// 获取所属门店
		GetOrgInfoListByConfig() {
			const paramer = {
				key: 1
			};
			return GetOrgInfoListByConfig(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.storeList = [];
						if (res.code == 1) {
							res.data.forEach((item) => {
								this.storeList.push({
									keyId: item.keyId,
									value: item.name + "【" + item.remark2 + "】"
								});
							});
						} else {
							this.$message.error(res.msg);
						}
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.$message.error("获取门店信息失败!");
				});
		},
		//获取状态信息
		GetEnumConfigListByCode() {
			const paramer = {
				code: "StoreOrderState"
			};
			return GetEnumConfigListByCode(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.stateList = [];
						res.data.forEach((item) => {
							this.stateList.push({
								code: parseInt(item.code),
								name: item.name
							});
						});
						this.stateList.unshift({
							code: 0,
							name: "全部"
						});
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.$message.error("获取状态信息失败!");
				});
		},
		//获取订单类型信息
		GetOrderTypeListByCode() {
			const paramer = {
				code: "OrderType"
			};
			return GetEnumConfigListByCode(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.orderTypeList = [];
						res.data.forEach((item) => {
							this.orderTypeList.push({
								code: parseInt(item.code),
								name: item.name
							});
						});
						this.orderTypeList.unshift({
							code: 0,
							name: "全部"
						});
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.$message.error("获取状态信息失败!");
				});
		},
		//获取订单来源信息
		GetOrderSourceEnumConfigListByCode() {
			const paramer = {
				code: "StoreOrderSource"
			};
			return GetEnumConfigListByCode(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.orderSourceList = [];
						res.data.forEach((item) => {
							this.orderSourceList.push({
								code: parseInt(item.code),
								name: item.name
							});
						});
						this.orderSourceList.unshift({
							code: 0,
							name: "全部"
						});
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.$message.error("获取订单来源信息失败!");
				});
		},
		// 高级筛选回调
		filterMoreCallBack(params) {
			this.formInline = params;
			this.search();
		},
		//展示选择商品
		showSelectGoods(type, paramsKeyId1, paramsKeyId2) {
			this.$refs.selectGoods.showSelectGoodsDialog(type, paramsKeyId1, paramsKeyId2);
		},
		// 选中商品
		chooseGoods(selectionList) {
			if (this.createOrEdit === 1) {
				this.$refs.create.submitSelectGoods(selectionList);
			} else {
				this.$refs.edit.submitSelectGoods(selectionList);
			}
		},
		// 查看详情
		handleSeeDetail(row) {
			this.$refs.storeDetail.showSeeDetailDialog(row, 1);
		},
		// 查看原订单详情
		handleSeeYuanDetail(row) {
			this.$refs.storeDetail.showSeeDetailDialog(row, 2);
		},
		// 门店批量录入快递单号
		handleBatchInputStoreKDNo() {
			if (this.selectionRowKeyIds.length == 0) {
				this.$message.error("请选择订单");
				return;
			}
			this.kdNo = "";
			this.dialogVisible = true;
		},
		// 输入快递单号后提交
		handleKDNoSubmit() {
			if (this.kdNo == "") {
				this.$message.error("请输入快递单号");
				return;
			}
			let params = {
				keyIds: this.selectionRowKeyIds,
				kdNo: this.kdNo
			};
			BatchSaveStoreKDNo(params).then((res) => {
				if (res.code == 1) {
					this.$message({
						type: "success",
						message: "快递单号录入成功！"
					});
					this.dialogVisible = false;
					this.getListData();
				} else {
					this.$message.error(res.msg);
				}
			});
		},
		// 订单确认
		handleConfirmOrder() {
			if (this.selectionRowKeyIds.length == 0) {
				this.$message.error("请选择订单");
				return;
			}
			let params = {
				keyIds: this.selectionRowKeyIds
			};
			ConfirmStoreOrder(params).then((res) => {
				if (res.code == 1) {
					this.$message({
						type: "success",
						message: "订单确认成功！"
					});
					this.getListData();
				} else {
					this.$message.error(res.msg);
				}
			});
		},
		// 选择行
		handleSelectionChange(val) {
			this.selectionRowKeyIds = val.map((item) => item.keyId);
		},
		// 订单完成
		handleFinishedOrder() {
			if (this.selectionRowKeyIds.length == 0) {
				this.$message.error("请选择订单");
				return;
			}
			this.$confirm("确定完成订单吗？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
				.then(() => {
					let params = {
						keyIds: this.selectionRowKeyIds
					};
					FinishedStoreOrder(params).then((res) => {
						if (res.code == 1) {
							this.$message({
								type: "success",
								message: "订单完成成功！"
							});
							this.getListData();
						} else {
							this.$message.error(res.msg);
						}
					});
				})
				.catch(() => {
					this.$message({
						type: "info",
						message: "已取消完成订单"
					});
				});
		},
		// 删除订单
		handleDeleteOrder(row) {
			this.$confirm("确定删除订单【" + row.orderNo + "】吗？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
				.then(() => {
					let params = {
						keyId: row.keyId
					};
					DeleteStoreOrder(params).then((res) => {
						if (res.code == 1) {
							this.$message({
								type: "success",
								message: "订单删除成功！"
							});
							this.getListData();
						} else {
							this.$message.error(res.msg);
						}
					});
				})
				.catch(() => {
					this.$message({
						type: "info",
						message: "已取消删除订单"
					});
				});
		},
		// 按钮权限
		getBtnPermission() {
			this.btnPermission.delete = this.$checkBtnPermission("/order/index", "delete");
			this.btnPermission.edit = this.$checkBtnPermission("/order/index", "edit");
		},
		//打开新窗口查询快递信息
		openNewWindowSearchKuaiDi(val) {
			if (val.startsWith("SF")) {
				window.open("https://www.sf-express.com/chn/sc/waybill/waybill-detail/" + val);
			} else {
				this.$message({
					type: "error",
					message: "不是顺丰单号，不支持快递信息查询！"
				});
			}
		},
		// 双击行打开修改界面
		handleRowDBClick(row) {
			this.createOrEdit = 2;
			if (row.state == 1 || row.state == 2) {
				this.$refs.edit.showEditDialog(row);
			}
		},
		// 批量修改快递单号
		handleBatchEditKDNo() {
			if (this.selectionRowKeyIds.length == 0) {
				this.$message.error("请选择订单");
				return;
			}
			this.editKDNo = "";
			this.dialogEditKDNoVisible = true;
		},
		// 输入快递单号后提交
		handleEditKDNoSubmit() {
			if (this.editKDNo == "") {
				this.$message.error("请输入快递单号");
				return;
			}
			let params = {
				keyIds: this.selectionRowKeyIds,
				kdNo: this.editKDNo
			};
			BatchEditStoreKDNo(params).then((res) => {
				if (res.code == 1) {
					this.$message({
						type: "success",
						message: "快递单号修改成功！"
					});
					this.dialogEditKDNoVisible = false;
					this.getListData();
				} else {
					this.$message.error(res.msg);
				}
			});
		}
	}
};
</script>

<style scoped>
.table-minheight {
	margin-top: 0;
}

.one_1 {
	background-color: rgb(250, 121, 1);
	display: inline-block;
	color: white;
	font-weight: bolder;
	padding: 2px 12px;
	border-radius: 999px;
	white-space: nowrap;
}

.one_2 {
	background-color: rgb(255, 0, 0);
	display: inline-block;
	color: white;
	font-weight: bolder;
	padding: 2px 12px;
	border-radius: 999px;
	white-space: nowrap;
}
</style>
